export default __webpack_public_path__ + "static/linda1-845956df32226c07235a30568aa23b5c.jpg";